import {
  getListCLTV,
} from '@/services/cltv';

const getters = {
  listUsers: state => state.listUsers,
  totalUsers: state => state.totalUsers,
  lifetimeAvgInDays: state => state.lifetimeAvgInDays,
  lifetimeRevenueAvg: state => state.lifetimeRevenueAvg,
};

const actions = {
  async requestListUsers({ commit }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListCLTV(filter);
      commit('SET_LIST_USERS', { listUsers: response.data, totalUsers: response.total_data,
        lifetimeAvgInDays: response.lifetime_avg_in_days, lifetimeRevenueAvg: response.lifetime_revenue_avg
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_USERS(state, { listUsers, totalUsers,lifetimeAvgInDays, lifetimeRevenueAvg  }) {
    state.listUsers = listUsers;
    state.totalUsers = totalUsers;
    state.lifetimeAvgInDays = lifetimeAvgInDays;
    state.lifetimeRevenueAvg = lifetimeRevenueAvg;
  },
};

export default {
  namespaced: true,
  state: {
    listUsers: [],
    totalUsers: 0,
    lifetimeAvgInDays: 0,
    lifetimeRevenueAvg: 0,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/CLTV/index.js